// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDLqG7J_JgB_2Z39q01ktOdaBguhoBgRJ8",
  authDomain: "e-rion-473806.firebaseapp.com",
  projectId: "e-rion-473806",
  storageBucket: "e-rion-473806.firebasestorage.app",
  messagingSenderId: "107200318033",
  appId: "1:107200318033:web:674a14f947c4e6442c4670",
  measurementId: "G-PPM14YPV3C"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
